import { render } from "./ProsesEvaluatan.vue?vue&type=template&id=fc16eabc"
import script from "./ProsesEvaluatan.vue?vue&type=script&lang=js"
export * from "./ProsesEvaluatan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__